import axios from 'axios';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.scss';
import '../../App.scss';
import { Box, Button, Typography } from '@mui/material';

const Login = () => {

  const handleDiscordLogin = async () => {
    try {
      const response = await axios.get('/api/auth/discord/login');
      console.log(response)
      window.location.replace(response.data.authUrl);
    } catch (error) {
      console.error('Error during Discord login:', error);
    }
  };

  useEffect(() => {
    handleDiscordLogin();
  }, []);

  return (
    <div>
      <h1>Login</h1>
      <Box className="StyledContent">
        <Box className="StyledButtonContainer">
          <Box className="StyledCard">
            <Typography variant="h5" className="StyledCardTitle">Login</Typography>
            <Typography variant="body1" className="StyledCardText">Click the button if it does not automatically redirect you to the Discord login.</Typography>
            <Button className="CustomButton" variant="contained" color="primary" onClick={handleDiscordLogin}>
              Login with Discord
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Login;
